export const FOOTER_PATHS = {
	CONTACT: '/kontakt'
};
